var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-content" }, [
    _vm.supporter
      ? _c("div", { staticClass: "module-header" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "router-link",
                {
                  staticClass: "back",
                  attrs: {
                    to: _vm.redirectTo,
                    title: "Back to list",
                    "select-cy": "back"
                  }
                },
                [_c("i", { staticClass: "icn icn-chevron-left" })]
              ),
              _c("h2", [
                _vm._v(
                  _vm._s(_vm.supporter.firstName || _vm.supporter.name) +
                    " " +
                    _vm._s(_vm.supporter.lastName)
                )
              ])
            ],
            1
          )
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "content w-full container module-item" },
      [
        _c("SupporterDetails", { attrs: { supporter: _vm.supporter } }),
        _c("SupporterDonations", { attrs: { supporter: _vm.supporter } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }